import React, { useEffect, useState, useCallback } from 'react';
import client from '../../../lib/feathers';
import Breadcrumb from '../../../components/Breadcrumb';
import Page from '../../../components/Page';
import PrimaryButton from '../../../components/PrimaryButton';
import { Link, NavLink, Route, Routes, useNavigate, useParams } from 'react-router-dom';
import BusinessInfoPanel from '../../../components/listingDetail/Overview/BusinesInfoPanel';
import LocationInfoPanel from '../../../components/listingDetail/Location/LocationInfoPanel';
import ContactInfoPanel from '../../../components/listingDetail/Overview/ContactInfoPanel';
import AccommodationsInfoPanel from '../../../components/listingDetail/Overview/AccommodationsInfoPanel';
import HoursInfoPanel from '../../../components/listingDetail/Overview/HoursInfoPanel';
import PromotionsPanel from '../../../components/listingDetail/Promotions/PromotionsPanel';
import FlightsInfoPanel from '../../../components/listingDetail/Flights/FlightsInfoPanel';
import UploadPhotoPanel from '../../../components/listingDetail/Gallery/UploadPhotoPanel';
import LibationsInfoPanel from '../../../components/listingDetail/Wines/LibationsInfoPanel';
import IndustryConnectionRequestPanel from '../../../components/listingDetail/Users/IndustryConnectionRequestPanel';
import { useDispatch, useSelector } from 'react-redux';
import { setListing } from '../../../lib/listingsSlice';
import ListingDetailNavigation from '../../../components/listingDetail/ListingDetailNavigation';
import LibationForm from "../../../components/listingDetail/Wines/LibationForm";
import FlightForm from "../../../components/listingDetail/Flights/FlightForm";
import ReportsPanel from '../../../components/listingDetail/Reports/ReportsPanel';
import ItineraryInfoPanel from '../../../components/listingDetail/Itineraries/ItineraryInfoPanel';
import ItineraryForm from '../../../components/listingDetail/Itineraries/ItineraryForm';
import LibationVintageForm from '../../../components/listingDetail/Wines/LibationVintageForm';
import LibationReview from '../../../components/listingDetail/Wines/LibationReview';
import VIPPanel from '../../../components/listingDetail/VIP/VIPPanel';
import IndustryPassportsInfoPanel from '../../../components/listingDetail/Passports/IndustryPassportsInfoPanel';
import IndustryPassportDetail from '../../../components/listingDetail/Passports/IndustryPassportDetail';
import IndustryPassportEdit from '../../../components/listingDetail/Passports/IndustryPassportEdit';
import UserPhotosPanel from '../../../components/listingDetail/UserPhotos/UserPhotosPanel';
import FeatureDisabled from '../../../components/FeatureDisabled';
import featureLevels from '../../../lib/featureLevels';

export default function ListingDetail() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { lid } = useParams();
  const listing = useSelector((s) => s.listings.selected);

  const getListing = async (id) => {
    try {
      const service = client.service(`industry/listing`);
      const result = await service.get(id);

      dispatch(setListing(result));
    } catch (e) {
      console.log('setlisting error', e);
    }
  };

  useEffect(() => {
    if (lid) {
      getListing(lid);
    }
  }, [lid]);

  const tabs = [
    { name: 'Overview', section: '', notifications: null, access: 'all' },
    { name: `Promotions`, section: 'promotions', notifications: null, access: 'all' },
    { name: `Gallery`, section: 'gallery', notifications: null, access: 'all' },
    { name: 'User Photos', section: 'user-photos', notifications: null, access: 'all' },
    { name: `Users`, section: 'users', notifications: listing?.notifications?.userRequests, access: 'all' },
    { name: `Wines`, section: 'wines', notifications: listing?.notifications?.userLibations, access: 'all' },
    { name: `Flights`, section: 'flights', notifications: null, access: 'all' },
    { name: `VIP`, section: 'vip', notifications: null, access: 'all' },
    { name: `Passports`, section: 'passports', notifications: listing?.notifications?.pendingPassports, access: 'all' },
    { name: `Reports`, section: 'reports', notifications: null, access: 'all' },
    { name: `Itineraries`, section: 'itineraries', notifications: null, access: ['Tour Company'] },
    { name: `Subscription`, section: 'subscription', notifications: null, access: 'all' }
  ]

  return (
    <Page>
      {listing
        ? (
          <div className="space-y-6">
            <div className="pb-5 border-b border-gray-200">
              <div className=" sm:flex sm:items-center sm:justify-between">
                <Breadcrumb elements={[{ name: `${listing?.name || 'Listing Detail'}` }]} />
                {/* <div className="mt-3 sm:mt-0 sm:ml-4">
                  <PrimaryButton onClick={() => navigate(`/industry/listings/${listing.id}/edit`)}>
                    Edit Listing
                  </PrimaryButton>
                </div> */}
              </div>
              <ListingDetailNavigation listing={listing} tabs={tabs} basePath={'/industry/listings'} />
            </div>

            <Routes>
              <Route path="/" element={<><BusinessInfoPanel /><LocationInfoPanel /><ContactInfoPanel /><AccommodationsInfoPanel /><HoursInfoPanel /></>} />
              <Route path="/gallery" element={<UploadPhotoPanel />} />
              <Route path="/user-photos" element={
                <FeatureDisabled flag={featureLevels.UPLOAD_GALLERY_PHOTOS} level={listing?.featureLevel || 0}>
                  <UserPhotosPanel />
                </FeatureDisabled>
              } />
              <Route path="/promotions" element={<PromotionsPanel />} />
              <Route path="/users" element={<IndustryConnectionRequestPanel />} />
              <Route path="/wines" element={<LibationsInfoPanel />} />
              <Route path="/wines/:wid" element={<LibationReview />} />
              <Route path="/wines/:wid/edit" element={<LibationForm />} />
              <Route path="/wines/:wid/:vid/edit" element={<LibationVintageForm />} />
              <Route path="/flights" element={<FlightsInfoPanel />} />
              <Route path="/flights/:fid/edit" element={<FlightForm />} />
              <Route path="/vip" element={<VIPPanel />} />
              <Route path="/passports" element={<IndustryPassportsInfoPanel />} />
              <Route path="/passports/:pid/edit" element={<IndustryPassportEdit />} />
              <Route path="/passports/:pid" element={<IndustryPassportDetail />} />
              <Route path="/reports" element={<ReportsPanel />} />
              <Route path="/itineraries" element={<ItineraryInfoPanel />} />
              <Route path="/itineraries/:iid/edit" element={<ItineraryForm />} />
            </Routes>

          </div>
        )
        : <div>Loading Listing</div>
      }
    </Page >
  );
}
